import { Box } from '@mui/material';
import { ConfigurationType, DependenciesContentViewType } from '../../dependencies/types';
import { ListElementWrapper } from '../../shared/ListElementWrapper';
import { CardContent } from './CardContent';
import { NoResults } from '../../shared/NoResults';
import { useSelector } from 'react-redux';
import { selectDependenciesConfigurationItem } from '../../../../reducers/documentation/documentationReducer';
import { useDependencies } from '../../dependencies/hooks/useDependencies';
import { ConfigurationItem } from '../../dependencies/DependenciesTypes';
import { useMetadata } from '../../metadata/useMetadata';
import { humanizeDate } from '../../../helpers/humanizeDate';
import { Virtuoso } from 'react-virtuoso';

interface CardListProps {
  list: ConfigurationItem[];
  crmOrgId: string;
}

export const MetadataCards = ({ list, crmOrgId }: CardListProps) => {
  const selectedDependency = useSelector(selectDependenciesConfigurationItem);
  const firstHistoryItem = selectedDependency?.history?.[0];
  const { handleSetConfigurationItem } = useDependencies(crmOrgId);
  const { setMetadataElement } = useMetadata();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflowY: 'auto',
        overflowX: 'hidden',
      }}
    >
      {list.length ? (
        <Virtuoso
          style={{ height: '100%' }}
          data={list}
          itemContent={(_, item) => (
            <Box key={'wrapper_' + item.id}>
              <ListElementWrapper
                elementId={item.id}
                sx={{
                  minHeight: '64px',
                  pr: 0,
                  pl: 0,
                  pt: 1.5,
                  pb: 1.5,
                }}
                onWrapperClick={() => {
                  handleSetConfigurationItem({
                    id: item.id,
                    dependencyType: item.type,
                    parentType: item.parentType as ConfigurationType,
                    name: item.name,
                    clearHistory: true,
                    contentType: DependenciesContentViewType.default,
                  });
                  setMetadataElement(item.id, item.type, crmOrgId);
                }}
                isHighlighted={
                  firstHistoryItem?.id === item.id ||
                  (firstHistoryItem?.name === item.name &&
                    firstHistoryItem?.objectName === item.objectName)
                }
                leftContent={
                  <CardContent
                    parentType={item.parentType as ConfigurationType}
                    label={item.label}
                    apiName={item.name}
                    date={humanizeDate({ dateOrTimestamp: item.annotations?.changedAt ?? '' })}
                    isActive={!!item.isActive}
                    dependencyType={item.type}
                  />
                }
              />
            </Box>
          )}
        />
      ) : (
        <Box pl={2}>
          <NoResults />
        </Box>
      )}
    </Box>
  );
};
